<template>
    <div class="p-3">
        <div class="row my-4" v-for="(s, si) in schools">
            <div class="d-flex justify-content-between w-100">
                <h4 class="mr-auto">{{ s.name }}</h4>
            </div>
            <table class="w-100">
                <thead>
                    <tr class="table-header">
                        <td class="text-white p-1">Date</td>
                        <td class="text-white p-1">Description</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, di) in blackoutDates(s)">
                        <td>
                            <v-date-picker
                                v-show="editBlackout === `s${si}d${di}`"
                                class="picker-container"
                                popover-align="left"
                                v-model="editDate"
                            ></v-date-picker>
                            <span v-if="editBlackout !== `s${si}d${di}`">{{
                                d ? moment(d.date).format("MM/DD/YYYY") : ""
                            }}</span>
                        </td>

                        <td>
                            <input
                                v-if="editBlackout === `s${si}d${di}`"
                                type="text"
                                class="form-control form-control-sm inline-input"
                                v-model="editDescription"
                            />
                            <span v-else="">{{ d.description }}</span>
                        </td>

                        <td>
                            <button
                                v-if="editBlackout === `s${si}d${di}`"
                                class="btn btn-sm btn-primary"
                                @click="saveBlackout(s, di)"
                            >
                                Save
                            </button>
                            <button
                                v-else=""
                                class="btn btn-sm btn-outline-primary"
                                @click="editBlackoutDate(s, si, d, di)"
                            >
                                Edit
                            </button>

                            <button
                                v-if="editBlackout === `s${si}d${di}`"
                                class="btn btn-sm btn-outline-danger"
                                @click="cancelEdit()"
                            >
                                Cancel
                            </button>
                            <button
                                v-else=""
                                class="btn btn-sm btn-danger"
                                @click="deleteBlackout(s, di)"
                            >
                                Delete
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <v-date-picker
                                class="picker-container"
                                popover-align="left"
                                v-model="newBlackoutDate[`date-${s.id}`]"
                            ></v-date-picker>
                        </td>
                        <td>
                            <div class="d-flex">
                                <input
                                    type="text"
                                    class="form-control form-control-sm inline-input"
                                    v-model="newBlackoutDate[`description-${s.id}`]"
                                />
                            </div>
                        </td>
                        <td>
                            <a
                                class="btn btn-sm btn-primary text-white font-weight-bold"
                                @click="addBlackoutDate(s)"
                                >ADD</a
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { fixDatePickers } from "../../plugins/fixDatePickers";

export default {
    name: "CptInsuranceProviders",
    mixins: [fixDatePickers],
    props: ["schools", "organization"],
    data() {
        return {
            newBlackoutDate: {},
            editBlackout: null,
            editDate: null,
            editDescription: null,
        };
    },
    methods: {
        blackoutDates(school) {
            if (
                school.blackout_dates &&
                school.blackout_dates.dates &&
                school.blackout_dates.dates.dates
            ) {
                return school.blackout_dates.dates.dates;
            }
            return [];
        },

        deleteBlackout(school, index) {
            school.blackout_dates.dates.dates.splice(index, 1);
            const payload = { blackout_dates: { dates: [...school.blackout_dates.dates.dates] } };
            axios
                .patch(
                    `/api/organizations/${this.organization.id}/funding/sources/${school.id}`,
                    payload
                )
                .then(r => {
                    this.$emit("schools-updated");
                })
                .catch(e => {
                    console.error(e);
                });
        },

        cancelEdit() {
            this.editBlackout = null;
            this.editDate = null;
            this.editDescription = null;
        },

        editBlackoutDate(school, schoolIndex, blackout, blackoutIndex) {
            this.editDate = new Date(blackout.date);
            this.editDescription = blackout.description;
            this.editBlackout = `s${schoolIndex}d${blackoutIndex}`;
        },

        saveBlackout(school, index) {
            school.blackout_dates.dates.dates.splice(index, 1, {
                date: this.editDate,
                description: this.editDescription,
            });
            const payload = { blackout_dates: { dates: [...school.blackout_dates.dates.dates] } };
            axios
                .patch(
                    `/api/organizations/${this.organization.id}/funding/sources/${school.id}`,
                    payload
                )
                .then(r => {
                    this.$emit("schools-updated");
                    this.cancelEdit();
                })
                .catch(e => {
                    console.error(e);
                });
        },

        addBlackoutDate(school) {
            let date = this.newBlackoutDate[`date-${school.id}`];
            let description = this.newBlackoutDate[`description-${school.id}`];
            if (!date || !description) return;

            let payload = {};
            payload.id = school.id;

            if (!school.blackout_dates) {
                school.blackout_dates = { dates: { dates: [] } }; //Display updates before closing the modal
                payload.blackout_dates = { dates: [] };
            } else {
                payload.blackout_dates = {
                    dates: [...school.blackout_dates.dates.dates],
                };
            }
            payload.blackout_dates.dates.push({ date, description });

            axios
                .patch(
                    `/api/organizations/${this.organization.id}/funding/sources/${school.id}`,
                    payload
                )
                .then(r => {
                    school.blackout_dates.dates.dates.push({ date, description });
                    this.newBlackoutDate = {};
                    this.$emit("schools-updated");
                })
                .catch(e => {
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped></style>
